export default "__VITE_ASSET__dd1zXy00__"